import React from 'react';
import classnames from 'classnames';
import PlainButtonOrLink from '../../Buttons/PlainButtonOrLink';
const Tab = ({ onClick , biData , dataHook , isActive , prefix , label , href , postfix , viewClassNames: s , innerRef ,  })=>{
    return /*#__PURE__*/ React.createElement(PlainButtonOrLink, {
        className: classnames(s['tab'], isActive && s['active-tab']),
        href: href,
        onClick: onClick,
        biData: biData,
        "data-hook": dataHook,
        innerRef: innerRef
    }, prefix && /*#__PURE__*/ React.createElement("div", {
        className: s['prefix']
    }, prefix), /*#__PURE__*/ React.createElement("span", {
        className: s['label']
    }, label), postfix);
};
Tab.displayName = 'Tab';
export default Tab;
